const ID_TOKEN_KEY = "id_token";
import SecureLS from "secure-ls";
const ls = new SecureLS({ encodingType: 'aes', isCompression: true });

export const getToken = () => {
  return ls.get(ID_TOKEN_KEY);
};

export const saveToken = token => {
  ls.set(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
  ls.remove(ID_TOKEN_KEY);
};

export default { getToken, saveToken, destroyToken };
